/**
 * Testimonial carousel
 */
(function () {
  document.querySelectorAll('[data-testimonial-carousel]').forEach((root) => {
    const slides = root.querySelectorAll('[data-testimonial-slide]');
    const counter = root.querySelector('[data-testimonial-counter]');
    if (slides.length <= 1) return;

    let current = 0;

    function goTo(index) {
      slides[current]?.classList.add('hidden');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.remove('hidden');
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
    }

    root.querySelector('[data-testimonial-next]')?.addEventListener('click', () => goTo(current + 1));
    root.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => goTo(current - 1));
  });
})();
